// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NLXg","colBig":"styles_colBig__3YFh_","colSmall":"styles_colSmall__3czqv","shopifyNameWrapper":"styles_shopifyNameWrapper__3XDYI"};